import { defineStore } from 'pinia'
import { type ISearchPageLink } from '@/stores/types'
import type { IGlobalAlert, ICompactLinkData, ICompactImage } from '@/components/main-header/types'

export const useGlobalSettingsStore = defineStore('globalSettings', () => {
  const createProfileLink = ref<ICompactLinkData | null>(null)
  const registerProfileLink = ref<ICompactLinkData | null>(null)
  const loginLink = ref<ICompactLinkData | null>(null)
  const globalAlert = ref<IGlobalAlert | null>(null)
  const searchPageLink = ref<ISearchPageLink | null>(null)
  const headerFlightStatusLink = ref<ICompactLinkData | null>(null)
  const ogImage = ref<ICompactImage | null>(null)
  const hideFsfPrices = ref<boolean>(false)
  const useOldFsf = ref<boolean>(false)
  const aqfBackLink = ref<ICompactLinkData | null>(null)
  const groupBookingLink = ref<ICompactLinkData | null>(null)
  const hasDataLoaded = ref(false)

  const init = async () => {
    if (hasDataLoaded.value) {
      return
    }

    const { locale } = useI18n()
    const { data, error } = await useFetch('/api/storyblok/global-settings', {
      query: {
        language: locale.value
      }
    })

    if (error.value) {
      console.error('\x1b[33m%s\x1b[0m', '[Error]: Something went wrong. Please try again.')
      return
    }

    searchPageLink.value = data.value?.searchPageLink ? data.value.searchPageLink : null

    loginLink.value = data.value?.loginLink ? data.value.loginLink : null
    ogImage.value = data.value?.ogImage ? data.value.ogImage : null
    hideFsfPrices.value = data.value?.hideFsfPrices ?? false
    useOldFsf.value = data.value?.useOldFsf ?? false

    headerFlightStatusLink.value = data.value?.headerFlightStatusLink ? data.value.headerFlightStatusLink : null
    aqfBackLink.value = data.value?.aqfBackLink ? data.value.aqfBackLink : null

    hideFsfPrices.value = data.value?.hideFsfPrices ?? false
    useOldFsf.value = data.value?.useOldFsf ?? false

    if (data.value?.globalAlert) {
      globalAlert.value = data.value?.globalAlert ? data.value.globalAlert : null
    }

    hasDataLoaded.value = true
  }

  return {
    init,
    createProfileLink,
    registerProfileLink,
    globalAlert,
    loginLink,
    searchPageLink,
    ogImage,
    headerFlightStatusLink,
    aqfBackLink,
    groupBookingLink,
    hideFsfPrices,
    useOldFsf
  }
})
